'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14(evaluator$24) {
  this.LK = null;
  this.LK = evaluator$24;
}
export { $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 as $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 };
$p = $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14;
/** @constructor */
function $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14() {
}
export { $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 as $h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 };
$h_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.LK.h();
  return ($j_java$002elang$002e$002dObject.$isInt(v) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14, "samples.Persons$package$$anon$7$$anon$12$$anon$14", ({
  q2: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 as $d_Lsamples_Persons$package$$anon$7$$anon$12$$anon$14 };
